<template>
  <t-popup v-model="showLoginToast" title="手机号验证">
    <div class="login-popup-wrapper">
      <van-form validate-first>
        <van-cell-group class="login__wrapper">
          <van-field
            class="input-wrap"
            v-model="mobile"
            clearable
            maxlength="11"
            type="tel"
            placeholder="请输入手机号"
          />
          <van-field
            class="input-wrap"
            v-model="verify_code"
            center
            clearable
            placeholder="请输入验证码"
          >
            <van-button
              class="code-btn"
              :disabled="disabled"
              slot="button"
              size="small"
              @click="getCode"
              >{{ textLoading }}</van-button
            >
          </van-field>
          <div class="login__btn_container">
            <van-button
              round
              class="login__btn"
              @click="loginHandler"
              :loading="loading"
              loading-text="加载中..."
              >确定</van-button
            >
          </div>
        </van-cell-group>
      </van-form>
    </div>
  </t-popup>
</template>

<script>
import { Field, CellGroup, Form } from 'vant'
import tPopup from '@/components/popup/index'
export default {
  name: 'bindPhoneComponent',
  components: {
    tPopup,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Form.name]: Form
  },
  data() {
    return {
      showLoginToast: false,
      mobile: null,
      verify_code: null,
      loading: false,
      disabled: false,
      textLoading: '获取验证码',
      timecount: 60
    }
  },
  created() {
    clearInterval(this.timer)
    console.log('$eventBus', this.$eventBus)
    this.$eventBus.$on('haddleLogin', () => {
      this.handleLoginToast(true)
    })
  },
  destroyed() {
    console.log('destroyed-1')
    clearInterval(this.timer)
  },
  methods: {
    async loginHandler() {
      if (this.loading) return
      if (!this.mobile || !this.verify_code) {
        this.$toast('请完善信息')
        return
      }

      this.loading = true

      const { data } = await this.$store.dispatch('login', {
        endpoint_type: 3,
        mobile: this.mobile,
        code: this.verify_code
      })

      this.loading = false

      if (data.code === 0) {
        this.$toast({
          duration: 800,
          message: '登录成功',
          onOpened: () => {
            this.handleLoginToast(false)
            // this.$router.go(0)

            let { path, query } = this.$route

            if (query.token) {
              query = {
                ...query,
                token: localStorage.getItem('token') || ''
              }
            }

            this.$router.replace({ path, query })
            window.location.reload()
          }
        })
      }
    },

    async getCode() {
      if (this.loading) return
      if (!this.mobile) {
        this.$toast('请输入手机号码')
        return
      }
      if (this.disabled) return

      this.loading = true

      const { data } = await this.$api.user.sendMobileVerify({ mobile: this.mobile })

      this.loading = false

      if (data.code == 0) {
        this.$toast('验证码获取成功')
        this.timecount = 60
        this.codeLoading()
      } else {
        this.textLoading = '获取验证码'
      }
    },

    codeLoading() {
      this.disabled = true

      this.timer = setInterval(() => {
        if (this.timecount <= 0) {
          clearInterval(this.timer)

          this.disabled = false
          this.timecount = 0
          this.textLoading = '获取验证码'

          return
        }

        this.textLoading = `重新获取(${this.timecount}s)`
        this.timecount--
      }, 1000)
    },

    handleLoginToast(flag) {
      this.showLoginToast = flag
    }
  }
}
</script>

<style lang="less" scoped>
.login-popup-wrapper {
  .van-cell::after {
    display: none !important;
  }
  .login__wrapper {
    &::after {
      display: none !important;
    }
    .input-wrap {
      width: 100%;
      height: 80rpx;
      margin-bottom: 24rpx;
      padding: 0 16rpx;
      background: #f5f5f5;
      display: flex;
      align-items: center;

      .input {
        flex: 1;
        display: block;
        width: 100%;
        height: 100%;
        padding-left: 24rpx;
        font-size: 26rpx;
      }
    }
    .code-btn {
      background: none;
      color: #027bdb;
      border: none;
      box-shadow: none;
    }
    .login__btn_container {
      margin-top: 100rpx;
      button {
        border: none !important;

        &::before {
          display: none;
        }
      }

      .login__btn {
        width: 100%;
        height: 72rpx;
        background: #027bdb;
        text-align: center;
        line-height: 72rpx;
        color: #ffffff;
        font-size: 30rpx;
        letter-spacing: 2rpx;
        border-radius: 0;

        &.disabled {
          opacity: 0.5;
        }
      }
    }
  }
}

.van-hairline--top-bottom::after {
  display: none;
}
</style>
